import { FileHelper } from './../../../../../helpers/file-helper';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HtmlTemplateVar } from '../../../../../dto/templates/html-template-var';
import { HtmlEditorComponent } from '../../../../../shared/html-editor/html-editor.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HtmlTemplate } from '../../../../../dto/templates/html-template';
import { InvoicePdfTemplatesService } from '../../../../services/invoice-pdf-templates.service';
import { PdfGeneratorService } from '../../../../../services/pdf-generator.service';

@Component({
  selector: 'app-invoice-pdf-templates-edit',
  templateUrl: './invoice-pdf-templates-edit.component.html',
  styleUrls: ['./invoice-pdf-templates-edit.component.css']
})
export class InvoicePdfTemplatesEditComponent implements OnInit {

  commands: HtmlTemplateVar[];

  id: number;

  selectedLanguage = 0;

  @ViewChild(HtmlEditorComponent, { static: false }) editor: HtmlEditorComponent;

  constructor(
    private templatesService: InvoicePdfTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private pdfGeneratorService: PdfGeneratorService
  ) { }

  templateForm: FormGroup;

  selectLanguage(lang: number){

    if( Number.isNaN(this.id) ){
      alert('English template must be saved first.');
      return;
    }

    if (this.templateForm.dirty){
      if(!confirm('Changes not saved. Do you want to proceed?')){
        return;
      }
    }

    this.navigateToLanguage(lang);

  }

  navigateToLanguage(lang: number){
    window.location.href = '/administration/templates/invoice-pdf/'+this.id+'?lang='+lang;
  }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    const lang = parseInt(this.route.snapshot.queryParamMap.get('lang'));

    if( Number.isNaN(lang) ){
      this.selectedLanguage = 1;
    }else{
      this.selectedLanguage = lang;
    }

    if (Number.isNaN(this.id)) {
      this.initForm(new HtmlTemplate());
    } else {
      this.templatesService.get(this.id).subscribe(result => {
        this.initForm(result);
      });
    }
  }

  insert(command: string) {
    this.editor.insertHtml(command);
  }

  initForm(template: HtmlTemplate) {

    this.templateForm = this.formBuilder.group({
      id: template.id,
      name: template.name,

      html: template.html,
      mjml: template.mjml,

      mjmlEn: template.mjmlEn,
      htmlEn: template.htmlEn,
    });


    this.templatesService.getVars().subscribe(result => {
      this.commands = result.data;
    });
  }

  goBack() {
    this.router.navigate(['../..'], { relativeTo: this.route });
  }

  onSubmit(form: FormGroup) {
    if (Number.isNaN(this.id)) {
      this.templatesService.add(form.value).subscribe(res => {
        this.id = res;
        this.navigateToLanguage(this.selectedLanguage);
      });
    } else {
      this.templatesService.update(this.id, form.value).subscribe(res => this.navigateToLanguage(this.selectedLanguage));
    }
  }

  generatePdf() {
    this.pdfGeneratorService.generatePdf(this.templateForm.value).subscribe(result => {
      FileHelper.saveFile(result);
    });
  }
}
